/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quicktools_Tab_InfoInputs */

const en_quicktools_tab_info = /** @type {(inputs: Quicktools_Tab_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Info`)
};

const fr_quicktools_tab_info = /** @type {(inputs: Quicktools_Tab_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Infos`)
};

const de_quicktools_tab_info = /** @type {(inputs: Quicktools_Tab_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Info`)
};

const it_quicktools_tab_info = /** @type {(inputs: Quicktools_Tab_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informazioni`)
};

const ru_quicktools_tab_info = /** @type {(inputs: Quicktools_Tab_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Информация`)
};

const es_quicktools_tab_info = /** @type {(inputs: Quicktools_Tab_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Información`)
};

const zh_cn2_quicktools_tab_info = /** @type {(inputs: Quicktools_Tab_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`信息`)
};

const ja_quicktools_tab_info = /** @type {(inputs: Quicktools_Tab_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`情報`)
};

const hi_quicktools_tab_info = /** @type {(inputs: Quicktools_Tab_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`जानकारी`)
};

const pt_pt2_quicktools_tab_info = /** @type {(inputs: Quicktools_Tab_InfoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informações`)
};

/**
* | output |
* | --- |
* | "Info" |
*
* @param {Quicktools_Tab_InfoInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const quicktools_tab_info = /** @type {((inputs?: Quicktools_Tab_InfoInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quicktools_Tab_InfoInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_quicktools_tab_info(inputs)
	if (locale === "de") return de_quicktools_tab_info(inputs)
	if (locale === "it") return it_quicktools_tab_info(inputs)
	if (locale === "ru") return ru_quicktools_tab_info(inputs)
	if (locale === "es") return es_quicktools_tab_info(inputs)
	if (locale === "zh-CN") return zh_cn2_quicktools_tab_info(inputs)
	if (locale === "ja") return ja_quicktools_tab_info(inputs)
	if (locale === "hi") return hi_quicktools_tab_info(inputs)
	if (locale === "pt-PT") return pt_pt2_quicktools_tab_info(inputs)
	return en_quicktools_tab_info(inputs)
});